"use strict";
/*
 * Created on 23. 11. 2018
 *
 * Copyright (c) 2018 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DomainObject_1 = require("../core/model/DomainObject");
/**
 * @author Stepan Mik
 */


var KpiRecord =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(KpiRecord, _DomainObject_1$Domai);

  function KpiRecord(kpiId, aggregate, parentIds, childCount, values, fractions) {
    var _this;

    _classCallCheck(this, KpiRecord);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(KpiRecord).call(this));
    _this.kpiId = kpiId;
    _this.aggregate = aggregate;
    _this.parentIds = parentIds;
    _this.childCount = childCount;
    _this.values = values;
    _this.fractions = fractions;
    return _this;
  }

  _createClass(KpiRecord, null, [{
    key: "kpiValue",
    value: function kpiValue(nom, denom) {
      //Zero denominator is used in KPI splits to indicate special form of aggregation of freeze KPIs
      return denom.isNaN() || denom.isZero() ? nom : nom.div(denom);
    }
  }]);

  return KpiRecord;
}(DomainObject_1.DomainObject);

exports.KpiRecord = KpiRecord;